import React from 'react';
import classNames from 'classnames';
import { Button, ButtonProps } from '@fiverr-private/button';
import { Container } from '@fiverr-private/layout_components';
import {
  tabButtonBorderStyle,
  tabContactButtonContainerStyle,
} from '../../ContactSeller/ContactSellerOptions/ContactButtonStyles/TabContent/TabContent.ve.css';

export const ContactButton = ({
  withAdditionalMargin = true,
  children,
  ...props
}: ButtonProps & { withAdditionalMargin?: boolean; children: React.ReactNode }) => (
  <Container className={classNames({ [tabContactButtonContainerStyle]: withAdditionalMargin })} position="relative">
    <Button {...props} className={tabButtonBorderStyle}>
      {children}
    </Button>
  </Container>
);
